<template>
    <QualificationField :title="$t('profile.vetting.qualification.email.address.title')">
        <VJoyWrapper no-margin>
            <TextField :content="qualification.emailAddress" :replace-by="$t('profile.vetting.qualification.email.address.empty.placeholder')" />
            <VJoyIconButton
                v-if="qualification.emailAddress"
                size="xsmall"
                icon="copy"
                variant="ghost"
                @click="clipboardCopy(qualification.emailAddress, $t('profile.vetting.qualification.email.address.copied'))"
            />
        </VJoyWrapper>
    </QualificationField>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {copyToClipboard} from '@malt/dom';
    import {pushVJoySnackbar, VJoyWrapper, VJoyIconButton} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();
    const {qualification} = storeToRefs(profileQualificationStore);

    function clipboardCopy(data: string, message: string) {
        copyToClipboard(data);
        pushVJoySnackbar({props: {message}});
    }
</script>
